import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PartDisplayService} from "../../services/part-display.service";

@Component({
    selector: 'mbnm-moulding-merch',
    templateUrl: './moulding-merch.component.html',
    styleUrls: ['./moulding-merch.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MouldingMerchComponent implements OnInit {

  constructor(public partDisplay: PartDisplayService) { }

  @Input()
  moulding: any;

  @Input()
  hangerType: string;

  public activeView = 'profile';

  setActive(view) {
    this.activeView = view;
  }

  ngOnInit() {
  }

}
